module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/179-ireland-71ac955cb9793141c4bc3dbdfefd2bf2.svg";